import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    imports: [CommonModule],
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
    @Input() title = 'Please Confirm';
    @Input() message = 'Are you sure you want to proceed?';
    @Input() confirmText = 'Yes';
    @Input() cancelText = 'No';

    @Output() confirmed = new EventEmitter<boolean>();

    show = false;

    open() {
        this.show = true;
    }

    close() {
        this.show = false;
    }

    confirm() {
        this.confirmed.emit(true);
        this.close();
    }

    cancel() {
        this.confirmed.emit(false);
        this.close();
    }
}
